export default __webpack_public_path__ + "static/media/Sunita.de04c351.jpg";